import * as types from './mutation-types'
import { getDimensionsVariables, setDimensionsVariables } from '../../../api/dimensionsVariables'

const getInitialState = () => {
  return {
    dimensionsVariables: {},
    unitesAjoutables: {}
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_DIMENSIONS_VARIABLES](state, dimensionsVariables) {
    state.dimensionsVariables = dimensionsVariables
  },
  [types.SET_UNITES_AJOUTABLES](state, unitesAjoutables) {
    state.unitesAjoutables = unitesAjoutables
  },
  [types.ADD_DIMENSION_VARIABLE](state, dimensionVariable) {
    state.dimensionsVariables.push(dimensionVariable)
  },
  [types.DEL_DIMENSION_VARIABLE](state, index) {
    state.dimensionsVariables[index].deleted = true
    state.dimensionsVariables = {
      ...state.dimensionsVariables
    }
  }
}

const actions = {
  async setDimensionsVariables({ commit }) {
    const dimensionsVariables = await getDimensionsVariables()
    commit(types.SET_DIMENSIONS_VARIABLES, dimensionsVariables)
  },
  async addEmptyDimensionVariable({ commit }) {
    const dimensionVariable = {
      'codeUnite': '',
      'longueurVariable': false,
      'largeurVariable': false,
      'hauteurVariable': false,
      'diametreVariable': false,
      'densiteVariable': false,
      'contenanceVariable': false,
      'poidsVariable': false,
      'ephemere': true
    }
    commit(types.ADD_DIMENSION_VARIABLE, dimensionVariable)
  },
  async enregistreDimensionsVariables({ commit }) {
    const updatedDimensionsVariables = await setDimensionsVariables(state.dimensionsVariables)
    commit(types.SET_DIMENSIONS_VARIABLES, updatedDimensionsVariables)
  },
  async deleteDimensionVariable({ commit }, index) {
    commit(types.DEL_DIMENSION_VARIABLE, index)
  },
  async setUnitesAjoutables({ state, commit, dispatch, rootState }) {
    if (!rootState.unite.unites || rootState.unite.unites.length === undefined || rootState.unite.unites.length < 1) {
      await dispatch('setUnites')
    }

    let unitesAjoutables = []
    let unites = rootState.unite.unites
    let dimVar = state.dimensionsVariables
    for (let keyUnit in rootState.unite.unites) {
      //cherche si l'unité a déjà été défini
      let alreadySet = false
      for (let keyDimVar in dimVar) {
        if ((unites[keyUnit].codeUnite === dimVar[keyDimVar].codeUnite) && !dimVar[keyDimVar].ephemere) {
          alreadySet = true
        }
      }
      //Si elle n'est pas défini, elle est ajoutable
      if (!alreadySet) {
        unitesAjoutables.push(unites[keyUnit].codeUnite)
      }
    }
    commit(types.SET_UNITES_AJOUTABLES, unitesAjoutables)
  }
}

const getters = {
  dimensionsVariables: state => state.dimensionsVariables,
  unitesAjoutables: state => state.unitesAjoutables
}

export default { state, mutations, actions, getters }
